import { Modulo } from 'src/app/shared/enums/domain/modulo';
import { UsuarioFuncao } from 'src/app/shared/enums/domain/usuario-funcao.enum';

export interface MenuItem {
  icone: string;
  nome: string;
  path?: string;
  /** Preenchido pelo `SideMenuComponent`; ver `MenuItem` em `menu-config.interface`. */
  rota?: string[];
  subItems?: MenuItem[];
}

export interface MenuParticao {
  particao: { nome: string };
  path?: string;
  items: MenuItem[];
}

const menuAdministradora: MenuParticao[] = [
  {
    path: 'administradora',
    particao: { nome: 'INÍCIO' },
    items: [{ icone: 'bx bx-grid-alt', nome: 'Dashboard', path: 'dashboard' }],
  },
  {
    path: 'administradora',
    particao: { nome: 'CADASTRO' },
    items: [
      { icone: 'bx bx-buildings', nome: 'Corretoras', path: 'corretoras' },
      { icone: 'bx bx-group', nome: 'Entidades', path: 'entidades' },
      { icone: 'bx bxs-bank', nome: 'Operadoras', path: 'operadoras' },
      { icone: 'bx bx-clipboard', nome: 'Planos', path: 'planos' },
      { icone: 'bx bx-table', nome: 'Tabelas', path: 'tabelas' },
    ],
  },
  {
    path: 'administradora',
    particao: { nome: 'CONSULTAS' },
    items: [{ icone: 'bx bx-file-find', nome: 'Propostas', path: 'propostas' }],
  },
  {
    path: 'administradora',
    particao: { nome: 'RELATÓRIOS' },
    items: [
      { icone: 'bx bx-group', nome: 'Usuários', path: 'relatorios/usuarios' },
      { icone: 'bx bx-export', nome: 'Propostas', path: 'relatorios/propostas' },
    ],
  },
  {
    path: 'administradora',
    particao: { nome: 'OUTROS' },
    items: [
      { icone: 'bx bx-file-blank', nome: 'Arquivos', path: 'arquivos' },
      { icone: 'bx bx-badge', nome: 'Coparticipações', path: 'coparticipacoes' },
      { icone: 'bx bx-group', nome: 'Usuários', path: 'usuarios' },
    ],
  },
];

const menuCorretora: MenuParticao[] = [
  {
    path: 'corretora',
    particao: { nome: 'GESTÃO' },
    items: [
      { icone: 'bx bx-bar-chart-alt-2', nome: 'Painel', path: 'dashboard' },
      { icone: 'bx bx-export', nome: 'Relatórios', path: 'relatorios' },
    ],
  },
  {
    path: 'corretora',
    particao: { nome: 'CADASTRO' },
    items: [
      { icone: 'bx bx-group', nome: 'Usuários' },
      { icone: 'bx bx-file-blank', nome: 'Filiações', path: 'filiacoes' },
    ],
  },
  {
    path: 'corretora',
    particao: { nome: 'PRODUTOS' },
    items: [
      { icone: 'bx bx-table', nome: 'Tabelas De Preço', path: 'tabelas' },
      { icone: 'bx bx-calendar-alt', nome: 'Vigências', path: 'vigencias' },
    ],
  },
  {
    path: 'corretora',
    particao: { nome: 'VENDAS' },
    items: [
      { icone: 'bx bx-user', nome: 'Corretores' },
      { icone: 'bx bx-file-find', nome: 'Propostas', path: 'propostas' },
    ],
  },
];

const menuVendas: MenuParticao[] = [
  {
    path: 'corretor',
    particao: { nome: 'GESTÃO' },
    items: [
      { icone: 'bx bx-bar-chart-alt-2', nome: 'Painel', path: 'dashboard' },
      { icone: 'bx bx-export', nome: 'Relatórios', path: 'relatorios' },
    ],
  },
  {
    path: 'corretor',
    particao: { nome: 'PROPOSTAS' },
    items: [
      {
        icone: 'bx bx-file-find',
        nome: 'Propostas',
        subItems: [
          { icone: 'bx bx-file-find', nome: 'Abertas', path: 'propostas/abertas' },
          { icone: 'bx bx-check-circle', nome: 'Concluídas', path: 'propostas/concluidas' },
          { icone: 'bx bx-x-circle', nome: 'Canceladas', path: 'propostas/canceladas' },
        ],
      },
    ],
  },
  {
    path: 'corretor',
    particao: { nome: 'OUTROS' },
    items: [
      { icone: 'bx bx-file-blank', nome: 'Filiações', path: 'filiacoes' },
      { icone: 'bx bx-calendar-alt', nome: 'Vigências', path: 'vigencias' },
    ],
  },
];

const menuAnalista: MenuParticao[] = [
  {
    path: 'analista',
    particao: { nome: 'GESTÃO' },
    items: [
      { icone: 'bx bx-bar-chart-alt-2', nome: 'Painel', path: 'dashboard' },
      { icone: 'bx bx-export', nome: 'Relatórios', path: 'relatorios' },
    ],
  },
  {
    path: 'analista',
    particao: { nome: 'PROPOSTAS' },
    items: [
      { icone: 'bx bx-file-find', nome: 'Propostas', path: 'propostas' },
    ],
  },
];

const menusPorModulo: { [key in Modulo]?: MenuParticao[] } = {
  [Modulo.ADMINISTRADORA]: menuAdministradora,
  [Modulo.CORRETORA]: menuCorretora,
  [Modulo.VENDAS]: menuVendas,
  [Modulo.ANALISE]: menuAnalista,
};

/**
 * Itens do módulo corretora que o supervisor não vê.
 *
 * Gestor e supervisor compartilham o módulo — não há módulo de supervisor —, e
 * até aqui viam o mesmo menu. Mas o supervisor responde pela própria equipe: a
 * API já filtra as propostas por `supervisor_id` e devolve 404 para proposta de
 * outro supervisor. Cadastrar usuário da corretora é administração da
 * corretora, não da equipe, e é o que fica de fora. Filiações continua, porque
 * é ali que o corretor pede para entrar na equipe.
 */
const ITENS_SO_DO_GESTOR = ['Usuários'];

export function buscarMenuDoModulo(id: Modulo, funcaoId?: number): MenuParticao[] {
  const menu = menusPorModulo[id] || [];

  if (id !== Modulo.CORRETORA || Number(funcaoId) !== UsuarioFuncao.SUPERVISOR) {
    return menu;
  }

  // Partição que fica sem item nenhum sai junto — cabeçalho solto é ruído.
  return menu
    .map((particao) => ({
      ...particao,
      items: particao.items.filter((item) => !ITENS_SO_DO_GESTOR.includes(item.nome)),
    }))
    .filter((particao) => particao.items.length > 0);
}
